// extracted by mini-css-extract-plugin
module.exports = {"detailHeader":"request_detailHeader__vNvGj","spanStyle":"request_spanStyle__qggeA","Container":"request_Container__2KkCw"};